/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { generateQuarter } from '../Components/utils';
import * as actionTypes from './actionTypes';

const initialState = {
  priceLevelSearchdata: {
    rebateProgramCd: '-1',
    planType: 'COMM',
    drugFamily: 'all',
    quarterValue: generateQuarter(),
    manufacturerGrid: [],
    drugfamilyId: null,
    loadMfgGrid : true,
    loadDrugFamilyGrid : true,
    loadDrugTable : false
  },
  priceLevelErrors: [],
  manufacturerGrid: [],
  drugFamily: [],
  priceDetailsInputData: {
    planType: '',
    planTypeDesc: '',
    rebatePgmCode: '',
    rebatePgmCodeDesc: '',
    manufactId: '',
    manufactName: '',
    quarter: '',
    drugFamilyName: '',
    drugFamilyDesc: '',
    pageCount: 1,
    getDetailsGridOne: [],
    storeGridTwoData: [],
    showAllQuarters: true,
    rowsChanged: true,
    isCancelActive: true,
    counter: 0,
    successMessage: [],
    deletedRows: {},
  },
  priceDetailErrors: [],
  rebatePriceDetailsApi: [],
  storeRebatePriceDetails: {},
  getPlanDescApi: [],
  priceDetailGrids: [],
  storeUpdatedPage: {},
  blurPageState: [],
  overlapStateErr: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PRICE_LEVEL_SEARCH_INPUT_DATA:
      return { ...state, priceLevelSearchdata: action.payload };
    case actionTypes.PRICE_LEVEL_ERRORS:
      return { ...state, priceLevelErrors: action.payload };
    case actionTypes.PRICE_DETAILS_INPUT_DATA:
      return { ...state, priceDetailsInputData: action.payload };
    case actionTypes.PRICE_DETAIL_ERRORS:
      return { ...state, priceDetailErrors: action.payload };
    case actionTypes.PRICE_LEVEL_MANUFACTURER_GRID:
      return { ...state, manufacturerGrid: action.payload };
    case actionTypes.PRICE_LEVEL_DRUG_FAMILY:
      return { ...state, drugFamily: action.payload };
    case actionTypes.REBATE_PRICE_LEVEL_DETAILS_API:
      return { ...state, rebatePriceDetailsApi: action.payload };
    case actionTypes.STORE_REBATE_PRICE_DETAILS:
      return { ...state, storeRebatePriceDetails: action.payload };
    case actionTypes.GET_PLAN_TYPE_DESC:
      return { ...state, getPlanDescApi: action.payload };
    case actionTypes.PRICE_DETAILS_GRIDS:
      return { ...state, priceDetailGrids: action.payload };
    case actionTypes.STORE_UPDATED_PAGE:
      return { ...state, storeUpdatedPage: action.payload };
    case actionTypes.STORE_BLUR_STATE:
      return { ...state, blurPageState: action.payload };
    case actionTypes.STORE_OVERLAP_STATE_ERR:
      return { ...state, overlapStateErr: action.payload };
      case actionTypes.STORE_PRICE_LEVEL_ALL_LIST:
        return { ...state, storePriceLevelData: action.payload };
    default:
      return state;
  }
};

export default reducer;
